import {useEffect, useState} from 'react';
import {Stack, Typography} from '@mui/material';
import {useAppDispatch} from 'slices/hooks';
import {useUserSettings} from '../../../utils';
import {setLanguage} from '../../../slices/language/languageSlice';
import {LanguageOutlined} from '@mui/icons-material';
import i18n from 'i18n';
import {HeaderMenuItem} from './HeaderMenuItem';
import {useTranslation} from 'react-i18next';

type Option = {
    title: string;
    code: string;
};

const options: Option[] = [
    {title: 'ruLanguage', code: 'ru'},
    {title: 'enLanguage', code: 'en'},
];

export const LangSelect = () => {
    const {t} = useTranslation('header');
    const dispatch = useAppDispatch();
    const initialLang = options.find((el) => el.code === i18n.language);
    const [selected, setSelected] = useState<Option>(initialLang || options[0]);

    const onSuccessUpdateFunc = () => {
        window.location.reload(); // перезапускаем страницу для обновления ВСЕХ запросов
    };

    const {settings: localizationSettings, changeSettings} = useUserSettings(
        'localizationSettings',
        undefined,
        onSuccessUpdateFunc,
    );

    useEffect(() => {
        const language = selected.code;
        dispatch(setLanguage(language));
        if (language === i18n.language) return;
        changeSettings({...localizationSettings, language});
        i18n.changeLanguage(language);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n, selected]);

    return (
        <>
            <Stack>
                <Stack
                    direction='row'
                    alignItems='center'
                    gap={1}
                    sx={{padding: '4px 10px'}}
                >
                    <LanguageOutlined />
                    <Typography>{t('language')}</Typography>
                </Stack>
                {options.map((el) => {
                    const isActiveElement = el.code === selected.code;
                    return (
                        <HeaderMenuItem
                            key={el.code}
                            isActiveElement={isActiveElement}
                            onClick={() => setSelected(el)}
                            title={
                                <>
                                    {t(el.title)} ({el.code.toUpperCase()})
                                </>
                            }
                        />
                    );
                })}
            </Stack>
        </>
    );
};
